export const wordsLowerCaseInItemName = () => {
  const wordsToCheck = ["And", "With", "On", "In", "Day"];

  return wordsToCheck;
};
